import { RadioGroup as CompassRadioGroup } from "@circleco/compass/components/RadioGroup";
import { Controller, useFormContext } from "react-hook-form";

import { CHAT_NOTIFICATION_TYPES_OPTIONS } from "@/react/components/Spaces/constants";

import type { ChatNotificationLevel, SpaceFormValues } from "../../types";

export const ChatNotificationField = () => {
  const { control } = useFormContext<SpaceFormValues>();

  return (
    <Controller
      control={control}
      name="notification_type"
      render={({ field: { value, onChange } }) => {
        const selected: ChatNotificationLevel =
          value === "all" || value === "mentions" ? value : "never";
        return (
          <CompassRadioGroup
            legend=""
            legendProps={{ className: "sr-only" }}
            name="notification_type"
            value={selected}
            onValueChange={next => onChange(next as ChatNotificationLevel)}
            options={CHAT_NOTIFICATION_TYPES_OPTIONS.map(option => ({
              value: option.value,
              label: option.label,
              description: option.description,
            }))}
          />
        );
      }}
    />
  );
};
